const DefaultFallback = () => (
  <div className='absolute top-0 left-0 flex h-screen w-screen items-center justify-center'>
    <div className='loading loading-ring loading-xl' />
  </div>
);

export default DefaultFallback;
